// Mock data for the website

export const blogPosts = [
  {
    id: 1,
    title: 'The Future of Cloud Computing: Trends to Watch in 2025',
    excerpt: 'Explore the emerging trends in cloud technology, from edge computing to serverless architectures, and how they will transform business operations.',
    date: 'Jan 15, 2025',
    readTime: '5 min read',
    category: 'Cloud',
    categoryColor: 'bg-gradient-to-r from-blue-500 to-cyan-500',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
    author: 'John Smith',
  },
  {
    id: 2,
    title: 'AI and Machine Learning: Revolutionizing Business Intelligence',
    excerpt: 'Discover how artificial intelligence and machine learning are empowering businesses to make data-driven decisions and gain competitive advantages.',
    date: 'Jan 10, 2025',
    readTime: '7 min read',
    category: 'AI/ML',
    categoryColor: 'bg-gradient-to-r from-violet-500 to-purple-500',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
    author: 'Sarah Johnson',
  },
  {
    id: 3,
    title: 'Digital Transformation: A Complete Guide for Enterprises',
    excerpt: 'Learn the essential steps for successful digital transformation, from strategy development to implementation and continuous optimization.',
    date: 'Jan 5, 2025',
    readTime: '6 min read',
    category: 'Digital',
    categoryColor: 'bg-gradient-to-r from-teal-500 to-emerald-500',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80',
    author: 'Michael Chen',
  },
  {
    id: 4,
    title: 'Microsoft Azure: Best Practices for Enterprise Migration',
    excerpt: 'A comprehensive guide to migrating enterprise workloads to Azure, including security considerations and cost optimization strategies.',
    date: 'Dec 28, 2024',
    readTime: '8 min read',
    category: 'Microsoft',
    categoryColor: 'bg-gradient-to-r from-blue-500 to-indigo-500',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80',
    author: 'Emily Rodriguez',
  },
  {
    id: 5,
    title: 'Cybersecurity in 2025: Protecting Your Digital Assets',
    excerpt: 'Stay ahead of emerging cyber threats with the latest security practices, tools, and strategies to safeguard your business infrastructure.',
    date: 'Dec 20, 2024',
    readTime: '6 min read',
    category: 'Security',
    categoryColor: 'bg-gradient-to-r from-rose-500 to-pink-500',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
    author: 'David Park',
  },
  {
    id: 6,
    title: 'The Rise of Low-Code Development Platforms',
    excerpt: 'Explore how low-code platforms are democratizing application development and accelerating digital innovation across industries.',
    date: 'Dec 15, 2024',
    readTime: '5 min read',
    category: 'Development',
    categoryColor: 'bg-gradient-to-r from-amber-500 to-orange-500',
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80',
    author: 'Lisa Wong',
  },
];